import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API_ENDPOINTS } from '../constants/api-endpoints.constant';

@Injectable({
  providedIn: 'root'
})
export class MyInterestService {

  constructor(private _apiService: ApiService) { }

  getMyInterest(params = "") {
    return this._apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.INTERESTS + params)
  }

  createTaggedInterestToUser(data) {
    return this._apiService.post(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.TAGGED_INTEREST_TO_USERS, data, true);
  }

  getTaggedInterestOfUser() {
    return this._apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.GET_TAGGED_INTEREST_TO_USERS)
  }
}
